import React from 'react';

const SizeAccessory = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4217_80)">
            <path
                d="M6.86192 9.9563C6.03527 11.0412 5.54443 12.3959 5.54443 13.8651C5.54443 17.4304 8.43469 20.3207 12 20.3207C15.5653 20.3207 18.4556 17.4304 18.4556 13.8651C18.4556 12.3959 17.9647 11.0412 17.1381 9.9563"
                stroke="#323232"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M11.9281 11.9434L6.64648 6.7334L8.6582 3.67932H11.9281"
                stroke="#323232"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.68213 6.7334H17.3535"
                stroke="#323232"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M12.065 11.9434L17.3467 6.7334L15.335 3.67932H12.065"
                stroke="#323232"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_4217_80">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default SizeAccessory;
